import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useColorPalette } from '../../hooks/helper/useColor'

type BoxWithLabelProps = {
  label?: string
  size?: 'small' | 'medium'
  required?: boolean
  children: React.ReactNode
  extraStyle?: React.CSSProperties
}
const BoxWithLabel: React.FC<React.PropsWithChildren<BoxWithLabelProps>> = ({
  label,
  size,
  required,
  children,
  extraStyle,
}) => {
  const colorPalette = useColorPalette()

  return !label ? (
    <>{children}</>
  ) : (
    <Box
      py={size === 'small' ? '4px' : '8px'}
      style={{ clear: 'both' }}
      flexGrow={1}
      sx={extraStyle}
    >
      <Stack direction="row">
        <Typography
          color={colorPalette.grey[400]}
          variant="body2"
          sx={{ fontSize: size === 'small' ? '12px' : '14px' }}
        >
          {label}
        </Typography>
        {required && (
          <Typography color={colorPalette.error['main']} variant="caption">
            *
          </Typography>
        )}
      </Stack>
      {children}
    </Box>
  )
}

export { BoxWithLabel }
